import React from "react";
import "./PolicyScreen.scss";
import NavBar from "../../components/Navbarr";
import Footerr from "../../components/Footerr";

function PrivacyPolicy() {
  return (
    <>
      <NavBar />

      <div className="privacy-container">
        <div className="privacy-wrapper">
          <h1 className="privacy-title">Politique de confidentialité</h1>
          <p className="privacy-date">Dernière mise à jour : 2026</p>

          <section className="privacy-section">
            <h2>1. Introduction</h2>
            <p>
              Bienvenue chez <b>Mhiri Store</b>. Votre vie privée est importante
              pour nous. Cette Politique de confidentialité explique comment
              nous collectons, utilisons, protégeons et partageons vos données
              lorsque vous utilisez notre site et nos services.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Données que nous collectons</h2>
            <ul>
              <li>
                <b>Informations personnelles :</b> nom, email, téléphone,
                adresse de livraison.
              </li>
              <li>
                <b>Informations de commande :</b> produits achetés, montant,
                statut, historique d’achat.
              </li>
              <li>
                <b>Données de navigation :</b> pages visitées, appareil,
                navigateur, adresse IP (à des fins de sécurité et statistiques).
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. Comment utilisons-nous vos données ?</h2>
            <ul>
              <li>Traiter et livrer vos commandes.</li>
              <li>Améliorer votre expérience de navigation et d’achat.</li>
              <li>Répondre à vos demandes et messages.</li>
              <li>Assurer la sécurité de notre plateforme.</li>
              <li>Envoyer des offres/promotions (si vous acceptez).</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Partage des données</h2>
            <p>
              Mhiri Store ne vend jamais vos données. Nous pouvons partager
              certaines informations uniquement avec :
            </p>
            <ul>
              <li>Les services de livraison pour expédier vos produits.</li>
              <li>Les partenaires de paiement pour finaliser votre commande.</li>
              <li>Les autorités si la loi l’exige.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>5. Cookies</h2>
            <p>
              Nous utilisons des cookies pour améliorer la performance et
              personnaliser votre expérience. Vous pouvez désactiver les cookies
              depuis votre navigateur, mais certaines fonctions peuvent ne pas
              fonctionner correctement.
            </p>
          </section>

          <section className="privacy-section">
            <h2>6. Sécurité</h2>
            <p>
              Nous appliquons des mesures de sécurité pour protéger vos données
              contre tout accès non autorisé, modification ou divulgation.
              Cependant, aucun système n’est sécurisé à 100%.
            </p>
          </section>

          <section className="privacy-section">
            <h2>7. Vos droits</h2>
            <p>Vous avez le droit de :</p>
            <ul>
              <li>Accéder à vos données personnelles.</li>
              <li>Modifier ou corriger vos informations.</li>
              <li>Demander la suppression de vos données.</li>
              <li>Retirer votre consentement aux promotions.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>8. Contact</h2>
            <p>
              Pour toute question concernant cette Politique de confidentialité,
              veuillez nous contacter :
            </p>
            <div className="privacy-contact">
              <p>
                <b>Email :</b> support@mhiristore.com
              </p>
              <p>
                <b>Téléphone :</b> +216 XX XXX XXX
              </p>
            </div>
          </section>
        </div>
      </div>

      <Footerr />
    </>
  );
}

export default PrivacyPolicy;
